/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddTeamMemberDto } from '../models/AddTeamMemberDto';
import type { ChangeMemberRoleDto } from '../models/ChangeMemberRoleDto';
import type { CompaniesListResponseDto } from '../models/CompaniesListResponseDto';
import type { CompanyObjectResponseDto } from '../models/CompanyObjectResponseDto';
import type { ConfirmMemberDto } from '../models/ConfirmMemberDto';
import type { CreateCompanyDto } from '../models/CreateCompanyDto';
import type { CreateTeamDto } from '../models/CreateTeamDto';
import type { InviteMemberDto } from '../models/InviteMemberDto';
import type { JoinCompanyDto } from '../models/JoinCompanyDto';
import type { MembersListResponseDto } from '../models/MembersListResponseDto';
import type { SetTeamLeaderDto } from '../models/SetTeamLeaderDto';
import type { TeamsListResponseDto } from '../models/TeamsListResponseDto';
import type { TransferOwnerDto } from '../models/TransferOwnerDto';
import type { UpdateJoinSettingsDto } from '../models/UpdateJoinSettingsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompaniesService {
    /**
     * @returns CompanyObjectResponseDto Компания создана
     * @throws ApiError
     */
    public static companiesControllerCreate({
        requestBody,
    }: {
        requestBody: CreateCompanyDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/new',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyObjectResponseDto Данные для формы создания
     * @throws ApiError
     */
    public static companiesControllerNewForm(): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/new',
        });
    }
    /**
     * @returns CompaniesListResponseDto Мои компании
     * @throws ApiError
     */
    public static companiesControllerMy(): CancelablePromise<CompaniesListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies',
        });
    }
    /**
     * @returns CompanyObjectResponseDto Компания по коду приглашения
     * @throws ApiError
     */
    public static companiesControllerFindByCode({
        code,
    }: {
        code: string,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/by-code/{code}',
            path: {
                'code': code,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Карточка компании
     * @throws ApiError
     */
    public static companiesControllerOne({
        id,
    }: {
        id: string,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Дашборд компании
     * @throws ApiError
     */
    public static companiesControllerDashboard({
        id,
    }: {
        id: string,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/dashboard',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Владелец изменён
     * @throws ApiError
     */
    public static companiesControllerTransfer({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: TransferOwnerDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/transfer-owner',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyObjectResponseDto Приглашение отправлено
     * @throws ApiError
     */
    public static companiesControllerInvite({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: InviteMemberDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/members/invite',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyObjectResponseDto Заявка на вступление
     * @throws ApiError
     */
    public static companiesControllerJoin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: JoinCompanyDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/join',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyObjectResponseDto Членство подтверждено
     * @throws ApiError
     */
    public static companiesControllerConfirm({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: ConfirmMemberDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/members/confirm',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyObjectResponseDto Участник одобрен
     * @throws ApiError
     */
    public static companiesControllerApprove({
        id,
        userId,
    }: {
        id: string,
        userId: string,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/members/{userId}/approve',
            path: {
                'id': id,
                'userId': userId,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Участник заблокирован
     * @throws ApiError
     */
    public static companiesControllerBlock({
        id,
        userId,
    }: {
        id: string,
        userId: string,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/members/{userId}/block',
            path: {
                'id': id,
                'userId': userId,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Роль изменена
     * @throws ApiError
     */
    public static companiesControllerChangeRole({
        id,
        userId,
        requestBody,
    }: {
        id: string,
        userId: string,
        requestBody: ChangeMemberRoleDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/companies/{id}/members/{userId}/role',
            path: {
                'id': id,
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyObjectResponseDto Вы покинули компанию
     * @throws ApiError
     */
    public static companiesControllerLeave({
        id,
    }: {
        id: string,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/members/me/leave',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Настройки вступления обновлены
     * @throws ApiError
     */
    public static companiesControllerUpdateJoinSettings({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateJoinSettingsDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/companies/{id}/join-settings',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns MembersListResponseDto Участники компании
     * @throws ApiError
     */
    public static companiesControllerMembers({
        id,
    }: {
        id: string,
    }): CancelablePromise<MembersListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/members',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Команда создана
     * @throws ApiError
     */
    public static companiesControllerCreateTeam({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: CreateTeamDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/teams',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns TeamsListResponseDto Команды компании
     * @throws ApiError
     */
    public static companiesControllerTeams({
        id,
    }: {
        id: string,
    }): CancelablePromise<TeamsListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/teams',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Участник добавлен в команду
     * @throws ApiError
     */
    public static companiesControllerAddTeamMember({
        id,
        teamId,
        requestBody,
    }: {
        id: string,
        teamId: string,
        requestBody: AddTeamMemberDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{id}/teams/{teamId}/members',
            path: {
                'id': id,
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns MembersListResponseDto Участники команды
     * @throws ApiError
     */
    public static companiesControllerTeamMembers({
        id,
        teamId,
    }: {
        id: string,
        teamId: string,
    }): CancelablePromise<MembersListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/teams/{teamId}/members',
            path: {
                'id': id,
                'teamId': teamId,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Карточка команды
     * @throws ApiError
     */
    public static companiesControllerTeam({
        id,
        teamId,
    }: {
        id: string,
        teamId: string,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{id}/teams/{teamId}',
            path: {
                'id': id,
                'teamId': teamId,
            },
        });
    }
    /**
     * @returns CompanyObjectResponseDto Лидер команды назначен
     * @throws ApiError
     */
    public static companiesControllerSetLeader({
        id,
        teamId,
        requestBody,
    }: {
        id: string,
        teamId: string,
        requestBody: SetTeamLeaderDto,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/companies/{id}/teams/{teamId}',
            path: {
                'id': id,
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns CompanyObjectResponseDto Участник удалён из команды
     * @throws ApiError
     */
    public static companiesControllerRemoveTeamMember({
        id,
        teamId,
        userId,
    }: {
        id: string,
        teamId: string,
        userId: string,
    }): CancelablePromise<CompanyObjectResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/companies/{id}/teams/{teamId}/members/{userId}',
            path: {
                'id': id,
                'teamId': teamId,
                'userId': userId,
            },
        });
    }
}
